import { Fragment, useEffect, useState } from "react";
import {
  Checkbox,
  Grid,
  List,
  ListItem,
  ListItemText,
  Paper,
  Typography,
  Box,
} from "@mui/material";
import * as Yup from "yup";
import { Formik } from "formik";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { CancelOutlined, CheckCircle } from "@mui/icons-material";

import Error from "../Error/Error";
import { useAxios } from "../../hooks";
import pages from "../../constants/pages";
import DateTimePicker from "../../components/DateTimePicker";
import EventBookingSuccess from "../Success/EventBookingSuccess";
import { Autocomplete, LoadingButton, TextField } from "../../components";

const OuterBox = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // min-height: 75vh;
  width: [100%, 100%, 100%, 800px];
  // margin: 10% 0;
  padding: 0px;
  box-sizing: border-box;
  background: #ffffff;
`;

const OuterPaper = styled(Paper)`
  width: 100%;
  // padding-top: 15px;
  border-radius: 5px;
  min-height: 20vh;
  background: #ffd0d0;
  align-content: center;
  border-radius: 15px;
  border: 0.6px solid #0000001a;
  background-image: linear-gradient(
    164deg,
    rgb(232 232 255) 3%,
    rgb(255, 255, 255) 31%
  );
  margin-bottom: 10px;
`;

function OutingPassPage() {
  const axios = useAxios();
  const navigate = useNavigate();
  const location = useLocation();
  const { visitorData } = useSelector((state) => state.memberDetails);

  const queryParams = new URLSearchParams(location.search);
  let type = queryParams.get("type");
  let campusID = queryParams.get("campusID");
  let passId = queryParams.get("passid");
  let gatePassId = queryParams.get("gatepassid");

  const [open, setOpen] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState(undefined);
  const [passDetail, setPassDetail] = useState({});
  const [displayMessage, setDisplayMessage] = useState("");
  const [redirectURL, setRedirectURL] = useState("");
  const [zones, setZones] = useState([]);

  const [formData, setFormData] = useState({
    Exit_Date: "",
    Return_Date: "",
    placeGoing: "",
    purposeOfExit: "",
    zones: [],
    consent: false,
  });

  useEffect(() => {
    if (passId != "undefined") {
      axios({
        url:
          "attendance/gate-pass/gate-pass-config?gate_pass_config_id=" + passId,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setPassDetail(response.data);
        }
      });
    }

    if (gatePassId) {
      axios({
        url: "/attendance/gate-pass/get-gate-pass?gate_pass_id=" + gatePassId,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setFormData({
            Exit_Date: response.data?.from_time * 1000,
            Return_Date: response.data?.till_time * 1000,
            placeGoing: response.data?.visit_location,
            purposeOfExit: response.data?.purpose,
            zones: response.data?.zones || [],
            consent: response.data?.consent || false,
            gate_pass_id: response.data.gate_pass_id || "",
          });
        }
      });
    }

    axios({
      url: "/admin/zone/get-entity-zone/" + campusID,
      method: "GET",
      disableRedirect: true,
    }).then((response) => {
      if (response.status) {
        setZones(response.data);
      }
    });
  }, []);

  const validationSchema = Yup.object().shape({
    Exit_Date: Yup.string().required("Exit Date is required"),
    Return_Date: Yup.string().required("Return Date is required"),
    ...(passId != "undefined" &&
      type != "entry" && {
        placeGoing: Yup.string().required("Place is required"),
      }),
    ...(passId != "undefined" &&
      type != "entry" && {
        purposeOfExit: Yup.string().required("Purpose is required"),
      }),
    consent: Yup.boolean()
      .oneOf([true], "You must agree to the terms")
      .required("Consent is required"),
  });

  return (
    <Fragment>
      <Grid container flexDirection={"column"}>
        <Grid item padding={"20px"}>
          <Grid item container justifyContent={"center"}>
            <Grid item md={12} sl={6} sx={{ alignContent: "center" }}>
              <OuterBox>
                {status === undefined ? (
                  <Fragment>
                    <Formik
                      initialValues={formData}
                      enableReinitialize
                      validationSchema={validationSchema}
                      onSubmit={(formData) => {
                        setLoading(true);

                        let data =
                          passId == "undefined" || type == "entry"
                            ? {
                                visitor_id: visitorData.ID,
                                from:
                                  new Date(formData.Exit_Date).getTime() / 1000,
                                till:
                                  new Date(formData.Return_Date).getTime() /
                                  1000,
                                purpose: formData.purposeOfExit,
                                zone_ids: formData.zones.map(
                                  (item) => item._id
                                ),
                                consent: formData.consent,
                                premises_id: campusID,
                                gate_pass_type: formData.type,
                                gate_pass_config_id: passId,
                                gate_pass_id: formData.gate_pass_id,
                              }
                            : {
                                visitor_id: visitorData.ID,
                                from:
                                  new Date(formData.Exit_Date).getTime() / 1000,
                                till:
                                  new Date(formData.Return_Date).getTime() /
                                  1000,
                                purpose: formData.purposeOfExit,
                                visit_location: formData.placeGoing,
                                consent: formData.consent,
                                premises_id: campusID,
                                gate_pass_type: type,
                                gate_pass_config_id: passId,
                              };

                        axios({
                          url: "attendance/gate-pass/create-gate-pass",
                          method: "POST",
                          data: data,
                          disableRedirect: true,
                        }).then((response) => {
                          if (response.status) {
                            navigate(pages.CampusUserPage.route);
                          } else {
                            setOpen(!response?.status);
                            setDisplayMessage(response?.displayMessage);
                            setRedirectURL(response.data?.redirect_url);
                          }

                          setLoading(false);
                        });
                      }}
                    >
                      {(formikProps) => {
                        return (
                          <Fragment>
                            <OuterPaper elevation={3}>
                              <div>
                                <div>
                                  <Typography
                                    variant="h4"
                                    fontWeight={700}
                                    textAlign={"center"}
                                    // mb={3}
                                    mt={5}
                                  >
                                    APPLICATION FOR {type.toUpperCase()} PASS
                                  </Typography>

                                  <List sx={{ padding: "0px 0px 8px 0px" }}>
                                    <ListItem sx={{ padding: "10px" }}>
                                      <ListItemText
                                        primary={
                                          <Typography sx={{ fontSize: "15px" }}>
                                            {passId == "undefined"
                                              ? ""
                                              : passDetail?.text1}
                                          </Typography>
                                        }
                                      />
                                    </ListItem>
                                  </List>

                                  <Grid container spacing={3} p={"0px 20px"}>
                                    <Grid item xs={6}>
                                      <Typography
                                        sx={{
                                          fontSize: "15px",
                                          fontWeight: 900,
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {`${
                                          passId == "undefined" ||
                                          type == "entry"
                                            ? "Entry"
                                            : "Exit"
                                        } Date`}
                                      </Typography>
                                      <DateTimePicker
                                        required
                                        name="Exit_Date"
                                        placeholder={`${
                                          passId == "undefined" ||
                                          type == "entry"
                                            ? "Entry"
                                            : "Exit"
                                        } Date`}
                                        formikProps={formikProps}
                                        minDate={new Date().getTime()}
                                        minTime={new Date().getTime()}
                                        size="small"
                                      />
                                    </Grid>

                                    <Grid item xs={6}>
                                      <Typography
                                        sx={{
                                          fontSize: "15px",
                                          fontWeight: 900,
                                          marginBottom: "5px",
                                        }}
                                      >
                                        Return Date
                                      </Typography>
                                      <DateTimePicker
                                        required
                                        name="Return_Date"
                                        placeholder={"Return Date"}
                                        formikProps={formikProps}
                                        size="small"
                                        minDate={
                                          new Date(
                                            formikProps.values.Exit_Date
                                          ).getTime() || new Date().getTime()
                                        }
                                      />
                                    </Grid>

                                    {passId != "undefined" &&
                                      type != "entry" && (
                                        <Fragment>
                                          <Grid item xs={12}>
                                            <Typography
                                              sx={{
                                                fontSize: "15px",
                                                fontWeight: 900,
                                                marginBottom: "5px",
                                              }}
                                            >
                                              Place Going
                                            </Typography>
                                            <TextField
                                              required
                                              size="small"
                                              name="placeGoing"
                                              placeholder={"Place Going"}
                                              formikProps={formikProps}
                                            />
                                          </Grid>
                                        </Fragment>
                                      )}

                                    <Grid item xs={12}>
                                      <Typography
                                        sx={{
                                          fontSize: "15px",
                                          fontWeight: 900,
                                          marginBottom: "5px",
                                        }}
                                      >
                                        {`Purpose Of ${
                                          passId == "undefined" ||
                                          type == "entry"
                                            ? "Entry"
                                            : "Exit"
                                        } `}
                                      </Typography>
                                      <TextField
                                        size="small"
                                        required
                                        name="purposeOfExit"
                                        placeholder={`Purpose Of ${
                                          passId == "undefined" ||
                                          type == "entry"
                                            ? "Entry"
                                            : "Exit"
                                        } `}
                                        formikProps={formikProps}
                                      />
                                    </Grid>

                                    {(passId == "undefined" ||
                                      type == "entry") && (
                                      <Grid item xs={12}>
                                        <Typography
                                          sx={{
                                            fontSize: "15px",
                                            fontWeight: 900,
                                            marginBottom: "5px",
                                          }}
                                        >
                                          Select Zone
                                        </Typography>

                                        <Autocomplete
                                          multiple
                                          name={"zones"}
                                          placeholder="Select Zone"
                                          defaults={{
                                            primaryKey: "_id",
                                            displayLabel: "name",
                                          }}
                                          value={
                                            formikProps?.values?.zones || []
                                          }
                                          onChange={(_, values) => {
                                            formikProps.setFieldValue(
                                              `zones`,
                                              values
                                            );
                                          }}
                                          required={true}
                                          options={zones || []}
                                          formikProps={formikProps}
                                          size="small"
                                        />
                                      </Grid>
                                    )}
                                  </Grid>

                                  <List>
                                    <ListItem sx={{ padding: "10px" }}>
                                      <ListItemText
                                        primary={
                                          <Typography sx={{ fontSize: "15px" }}>
                                            {passId == "undefined"
                                              ? ""
                                              : passDetail?.text2}
                                          </Typography>
                                        }
                                      />
                                    </ListItem>
                                    <ListItem sx={{ padding: "2px" }}>
                                      <Checkbox
                                        name="consent"
                                        checked={formikProps.values.consent}
                                        onClick={(e) =>
                                          formikProps.setFieldValue(
                                            "consent",
                                            e.target.checked
                                          )
                                        }
                                      />
                                      <ListItemText
                                        primary={
                                          <Typography
                                            sx={{ fontWeight: "700" }}
                                          >
                                            I agree to all consent terms.
                                          </Typography>
                                        }
                                      />
                                    </ListItem>
                                  </List>
                                </div>
                              </div>
                            </OuterPaper>
                            <LoadingButton
                              onClick={formikProps.handleSubmit}
                              loading={loading}
                              disabled={
                                !formikProps.dirty || !formikProps.isValid
                              }
                              size="small"
                            >
                              Submit
                            </LoadingButton>
                          </Fragment>
                        );
                      }}
                    </Formik>
                  </Fragment>
                ) : (
                  <Fragment>
                    <Grid item container justifyContent={"center"} mb={5}>
                      {status ? (
                        <CheckCircle
                          sx={{ color: "green", fontSize: "45px" }}
                        />
                      ) : (
                        <CancelOutlined
                          sx={{ color: "red", fontSize: "45px" }}
                        />
                      )}
                    </Grid>

                    <Typography
                      variant="h3"
                      fontWeight={700}
                      textAlign={"center"}
                      sx={{ color: status ? "green" : "red" }}
                    >
                      {status ? "Submit Successfully" : "Failed"}
                    </Typography>
                  </Fragment>
                )}

                <Error
                  open={open}
                  setOpen={setOpen}
                  ErrorMessage={displayMessage}
                  handleOnClick={() => window.location.assign(redirectURL)}
                  buttonContent={redirectURL ? "Verify Again" : ""}
                />
              </OuterBox>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <EventBookingSuccess
        open={openSuccess}
        setOpen={setOpenSuccess}
        SuccessMessage={displayMessage}
        buttonContent={"Thanks"}
        handleOnClick={() => navigate(-1)}
      />
    </Fragment>
  );
}

export default OutingPassPage;
